<template>
    <div>
		<template v-if="data && data.ticketList">
			<el-card class="box-card MT20" v-loading="dataLoading"  v-for="(item,index) in data.ticketList" :key="index" >
			    <div slot="header" class="clearfix">
			        <span>
			            <span class="el-icon-data-line"></span> {{item.sessionName}} 
			        </span>
			    </div>
				<div class="page-list-box">					
					<el-table :data="item.list" border style="width: 100%"  size="small" stripe >
						<el-table-column prop="name" label="票品"></el-table-column>               
						<el-table-column prop="totalNum" label="总票数"></el-table-column>
						<el-table-column prop="sellNum" label="当前销售"></el-table-column>
						<!-- <el-table-column prop="cancelNum" label="已经取消"></el-table-column> -->
						<el-table-column prop="remainder" label="剩余可售"></el-table-column>
						<el-table-column prop="sellRate" label="当前出票率"></el-table-column>
						<el-table-column  label="销售金额">
							<template slot-scope="scope">
								<p>票品金额：{{scope.row.sellAmount}}</p>
								<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
							</template>
						</el-table-column>
						<el-table-column label="优惠">
							<template slot-scope="scope">
								<p>秀动承担优惠：{{scope.row.discountAmount}}</p>
								<p>B类承担优惠：{{scope.row.busDiscountAmount}}</p>
							</template>
						</el-table-column>
						<el-table-column  label="实际收入">
							<template slot-scope="scope">
								<p>票品金额：{{scope.row.income}}</p>
								<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
							</template>
						</el-table-column>
						<el-table-column  label="退票">
							<template slot-scope="scope">
								<p>退票数：{{scope.row.cancelNum}}</p>
								<p>退票手续费：{{scope.row.refundFeeStr}}</p>
							</template>
						</el-table-column>
					</el-table>					
				</div>
				<div :id="`chart${index}`" class="MT20"></div>				
			</el-card>
		</template>
		
		<template v-if="data && data.throughTicketList.length > 0">
			<el-card class="box-card MT20" v-loading="dataLoading" >
				<div slot="header" class="clearfix">
					<span>
						<span class="el-icon-data-line"></span> 通票 
					</span>
				</div>
				<div class="page-list-box">				
					<el-table :data="data.throughTicketList" border style="width: 100%"  size="small" stripe>
						<el-table-column prop="name" label="票品"></el-table-column>               
						<el-table-column prop="totalNum" label="总票数"></el-table-column>
						<el-table-column prop="sellNum" label="当前销售"></el-table-column>						
						<el-table-column prop="remainder" label="剩余可售"></el-table-column>
						<el-table-column prop="sellRate" label="当前出票率"></el-table-column>
						<el-table-column label="销售金额">
							<template slot-scope="scope">
								<p>票品金额：{{scope.row.sellAmount}}</p>
								<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
							</template>
						</el-table-column>
						<el-table-column label="优惠">
							<template slot-scope="scope">
								<p>秀动承担优惠：{{scope.row.discountAmount}}</p>
								<p>B类承担优惠：{{scope.row.busDiscountAmount}}</p>
							</template>
						</el-table-column>
						<el-table-column label="实际收入">
							<template slot-scope="scope">
								<p>票品金额：{{scope.row.income}}</p>
								<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
							</template>
						</el-table-column>
						<el-table-column  label="退票">
							<template slot-scope="scope">
								<p>退票数：{{scope.row.cancelNum}}</p>
								<p>退票手续费：{{scope.row.refundFeeStr}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div id="chartTP"></div>
			</el-card>
		</template>
		
		<template v-if="data && data.presentTicketList.length >0">
			<el-card class="box-card MT20" v-loading="dataLoading" >
			    <div slot="header" class="clearfix">
			        <span>
			            <span class="el-icon-data-line"></span> 赠票 
			        </span>
			    </div>
				
				<div id="chartZP"></div>
			</el-card>
		</template>
		
		
       
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
		data:{
			type: Object,
			default: null,
		}
		
    },
    components: {},
    data() {
        return {
            dataLoading: false,
			ticketListChart:[],
			throughTicketListChart:[],
			presentTicketListChart:[]
           
        }
    },
    mounted() {
      this.drawAllCharts()
    },
	
    methods: {
		drawAllCharts() {
		    this.ticketListChart = this.data.ticketList ? [...this.data.ticketList] : []; //从后台获取数据
			this.throughTicketListChart =  this.data.throughTicketList ? [...this.data.throughTicketList] : []; //从后台获取数据
			this.presentTicketListChart = this.data.presentTicketList ? [...this.data.presentTicketList] : []; //从后台获取数据
		    if ( this.ticketListChart && this.ticketListChart.length > 0) {
		        this.$nextTick(() => {
		            this.initChart()
		        })
		    }
			if (this.throughTicketListChart && this.throughTicketListChart.length > 0) {
			    this.$nextTick(() => {
			        this.initChart2()
			    })
			}
			if ( this.presentTicketListChart && this.presentTicketListChart.length > 0) {
			    this.$nextTick(() => {
			        this.initChart3()
			    })
			}
			
		},
		initChart() {			
			this.ticketListChart.forEach((val, index) => {
				var _width = '100%';
				var chart = null;
				var chart1Data = []
				chart = new Chart({
				  container: `chart${index}`,
				  autoFit: true,
				  height: 200,
				  width:_width
				})
				val.list.forEach( a => {
					if( a.name ){
						chart1Data.push({
							name: a.name,
							type: '当前销售',
							value:a.sellNum
						});
					}
					if( a.remainder ){
						chart1Data.push({
							name: a.name,
							type: '剩余可售',
							value:a.remainder
						});
					}
				})			
			chart.data(chart1Data);
			chart.scale('value', {			
			  alias: '销量',
			});
			chart.axis('name', {
			  tickLine: null,
			  line: null,
			});
			chart.axis('value', {
			  label: null,
			  title: {
			    style: {
			      fontSize: 14,
			      fontWeight: 300,
			    },
			  },
			  grid: null,
			});
			chart.legend({
			  position: 'top',
			});
			chart.coordinate('rect').transpose();
			chart.tooltip({
			  shared: true,
			  showMarkers: false,
			});
			chart.interaction('active-region');
			chart
			  .interval()
			  .adjust('stack')
			  .position('name*value')
			  .color('type*name', (type, name) => {
			    if (type === '当前销售') {
			      return '#5b8ff9';
			    }
			    if (type === '剩余可售') {
			      return '#ced4d9';
			    }
			  
			  })
			  .size(26)
			  .label('value*type', (val, t) => {
			    const color = t === '当前销售' ? 'white' : '#47494b';
			    if (val < 0.05) {
			      return null;
			    }
			    return {
			      position: 'middle',
			      offset: 0,
			      style: {
			        fontSize: 12,
			        fill: color,
			        lineWidth: 0,
			        stroke: null,
			        shadowBlur: 2,
			        shadowColor: 'rgba(0, 0, 0, .45)',
			      },
			    };
			  });
			chart.render();
			})
		},		
		initChart2() {
			var chartTP = null
			var _width = '100%';
			var chart2Data = []
			if( chartTP ) chartTP.destroy();
			chartTP = new Chart({
			  container: `chartTP`,
			  autoFit: true,
			  height: 200,
			  width:_width
			})
			
			this.throughTicketListChart.forEach( a => {
				if( a.name ){
					chart2Data.push({
						name: a.name,
						type: '当前销售',
						value:a.sellNum
					});
				}
				if( a.remainder ){
					chart2Data.push({
						name: a.name,
						type: '剩余可售',
						value:a.remainder
					});
				}
			})			
			chartTP.data(chart2Data);
			chartTP.scale('value', {			
			  alias: '销量',
			});
			chartTP.axis('name', {
			  tickLine: null,
			  line: null,
			});
			chartTP.axis('value', {
			  label: null,
			  title: {
			    style: {
			      fontSize: 14,
			      fontWeight: 300,
			    },
			  },
			  grid: null,
			});
			chartTP.legend({
			  position: 'top',
			});
			chartTP.coordinate('rect').transpose();
			chartTP.tooltip({
			  shared: true,
			  showMarkers: false,
			});
			chartTP.interaction('active-region');
			chartTP
			  .interval()
			  .adjust('stack')
			  .position('name*value')
			  .color('type*name', (type, name) => {
			    if (type === '当前销售') {
			      return '#5b8ff9';
			    }
			    if (type === '剩余可售') {
			      return '#ced4d9';
			    }
			  
			  })
			  .size(26)
			  .label('value*type', (val, t) => {
			    const color = t === '当前销售' ? 'white' : '#47494b';
			    if (val < 0.05) {
			      return null;
			    }
			    return {
			      position: 'middle',
			      offset: 0,
			      style: {
			        fontSize: 12,
			        fill: color,
			        lineWidth: 0,
			        stroke: null,
			        shadowBlur: 2,
			        shadowColor: 'rgba(0, 0, 0, .45)',
			      },
			    };
			  });
			chartTP.render();	  
		},
		initChart3(){
			var chartZP = null
			if( chartZP ) chartZP.destroy();
			chartZP = new Chart({
			  container: `chartZP`,
			  autoFit: true,
			  height: 100,
			})
			
			chartZP.data(this.presentTicketListChart)
			
			chartZP.axis('keyStr', {
			  label: {
			    offset: 12,
				
			  }
			});
			
			chartZP.coord().transpose();
			
			
			chartZP.tooltip({			        
			        showTitle: false,//不显示标题
			        showMarkers: false,//不显示贴敷上去的小点
			        position: "right",//显示位置			       
			        itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {keyStr}，已发放:</span>
			       {num}
			        </div>
			        `,
			      });			 
			   chartZP.interval().position("keyStr*num").tooltip("keyStr*num", function (keyStr, num) {
			          return { keyStr, num };
			    });
			chartZP.render();
		}	
		
      
    }
}
</script>